<template>
  <div class="pt-[85px] px-[32px] flex flex-col gap-[16px]" data-test="qr-verify-personal-id">
    <div class="flex flex-col gap-[8px]">
      <h2 class="text-[2.25rem] leading-[2.375rem] font-black text-[#242425] tracking-[-0.03em]">
        Verify it’s you
      </h2>
      <p class="text-[1rem] leading-[1.5rem] font-normal text-[#2C2E34]">
        Enter the last 4 characters of your NRIC/FIN/passport and your date of birth so we can show
        your QR.
      </p>
    </div>

    <div class="w-full">
      <label :class="labelClass" for="qrVerifyDateOfBirth">Date of Birth</label>
      <DsDatePicker
        id="qrVerifyDateOfBirth"
        name="qrVerifyDateOfBirth"
        v-model="dateOfBirth"
        display-format="DD-MM-YYYY"
        placeholder="Enter your Date of Birth"
        :max="today"
        :disabled="isBlocked || submitting"
        :error="touched ? dateOfBirthError : ''"
      />
    </div>
    <div class="w-full">
      <label :class="labelClass" for="qrVerifyPartialNric">
        Last 4 chars of NRIC/FIN/Passport no.
      </label>
      <DsInput
        id="qrVerifyPartialNric"
        name="qrVerifyPartialNric"
        v-model="partialNric"
        placeholder="Eg: 123A"
        autocomplete="off"
        :max-length="4"
        :disabled="isBlocked || submitting"
        :error="touched ? partialNricError : ''"
      />
    </div>

    <DsAlert v-if="error" variant="error" data-test="qr-verify-error">
      {{ error.message }}
    </DsAlert>

    <DsButton
      variant="secondary"
      shape="pill"
      size="56"
      class="w-full"
      data-test="qr-verify-submit"
      :disabled="isBlocked || submitting"
      :loading="submitting"
      @click="submit"
    >
      {{ submitting ? 'Verifying...' : 'Verify' }}
    </DsButton>

    <ContactSupportButton v-if="error && error.offerSupport" />
  </div>
</template>

<script>
import { useStore } from 'vuex';
import {
  Alert as DsAlert,
  Button as DsButton,
  DatePicker as DsDatePicker,
  Input as DsInput,
} from '@team-hogc/hogc-one-design-system';
import ContactSupportButton from '@/components/common/ContactSupportButton.vue';
import { useVerifyPersonalIdForm } from '@/composables/useVerifyPersonalIdForm';

/**
 * My QR for a secondary login that has not yet confirmed the member's personal id
 * (giving per login): the profile hides the id (personalIdLocked), so there is no QR
 * to show and the generate form would be refused. The same check as MyGiving's
 * VerifyPersonalIdCard, asked of the main API (profile/verifyPersonalId). Emits
 * `verified` once the server accepts it.
 */
export default {
  name: 'QrVerifyPersonalId',
  components: { ContactSupportButton, DsAlert, DsButton, DsDatePicker, DsInput },
  emits: ['verified'],
  setup(_props, { emit }) {
    const store = useStore();
    return useVerifyPersonalIdForm({
      verify: fields => store.dispatch('profile/verifyPersonalId', fields),
      onVerified: result => emit('verified', result),
    });
  },
  data() {
    return {
      labelClass: 'block text-base text-primary font-inter font-medium mb-1 leading-5',
    };
  },
};
</script>
